import * as React from 'react'

function SvgDiscountIcon(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg
      width="1em"
      height="1em"
      viewBox="0 0 56 56"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M9.777 27.752l2.71-16.264 16.265-2.711 21.686 21.685-9.488 9.488"
        stroke="currentColor"
        strokeWidth={1.6}
        strokeLinejoin="round"
      />
      <circle
        cx={20}
        cy={19}
        r={2}
        stroke="currentColor"
        strokeWidth={1.6}
        strokeLinejoin="round"
      />
      <circle
        cx={15.806}
        cy={34.39}
        r={3.627}
        stroke="currentColor"
        strokeWidth={1.6}
        strokeLinejoin="round"
      />
      <circle
        cx={30.312}
        cy={45.27}
        r={3.627}
        stroke="currentColor"
        strokeWidth={1.6}
        strokeLinejoin="round"
      />
      <path
        d="M25.648 30.763l-5.006 18.683"
        stroke="currentColor"
        strokeWidth={1.6}
        strokeLinejoin="round"
      />
    </svg>
  )
}

export default SvgDiscountIcon
